import React from "react";
import { Animated, Platform, StyleProp, StyleSheet, TextStyle, View, ViewStyle } from "react-native";
import FontList from "react-native-font-list";
import SVG_Svg, { G as SVG_G, Path as SVG_Path, Text as SVG_Text, TSpan as SVG_TSpan } from "react-native-svg";
/* SVGR has dropped some elements not supported by react-native-svg: desc */

const TSpan = Animated.createAnimatedComponent(SVG_TSpan);
const Text = Animated.createAnimatedComponent(SVG_Text);
const Path = Animated.createAnimatedComponent(SVG_Path);
const G = Animated.createAnimatedComponent(SVG_G);
const Svg = Animated.createAnimatedComponent(SVG_Svg);
/***/

/*
 * -------------------------------------------------------------------------
 *
 *  /$$$$$$                                /$$$$$$$  /$$
 * |_  $$_/                               | $$__  $$| $$
 *   | $$   /$$$$$$/$$$$   /$$$$$$        | $$  \ $$| $$ /$$   /$$  /$$$$$$
 *   | $$  | $$_  $$_  $$ /$$__  $$       | $$$$$$$ | $$| $$  | $$ /$$__  $$
 *   | $$  | $$ \ $$ \ $$| $$  \ $$       | $$__  $$| $$| $$  | $$| $$$$$$$$
 *   | $$  | $$ | $$ | $$| $$  | $$       | $$  \ $$| $$| $$  | $$| $$_____/
 *  /$$$$$$| $$ | $$ | $$| $$$$$$$/  /$$  | $$$$$$$/| $$|  $$$$$$/|  $$$$$$$
 * |______/|__/ |__/ |__/| $$____/  |__/  |_______/ |__/ \______/  \_______/
 *                       | $$
 *                       | $$
 *                       |__/
 *
 * -------------------------------------------------------------------------
 *
 * ORIGINAL SVG
 * ---------------------------------
 * <svg xmlns="http://www.w3.org/2000/svg" width="221" height="46" viewBox="0 0 221 46" fill="none"> <desc id="IMP.BLUE">{"#tmtTitle":{"type":"SELECTOR","constraint":"none","width":221,"height":46},"#Group":{"type":"SELECTOR","constraint":"none","width":221,"height":46},"#Vector":{"type":"SELECTOR","constraint":"xMidYMid meet","width":14.468780517578125,"height":21},"#WHOLESALE_20MADE_20FOR_20YOU":{"type":"SELECTOR","constraint":"xMidYMid meet","width":162,"height":17},"#TmtTitle":{"type":"SELECTOR","constraint":"none","width":221,"height":46}}</desc>
 * <g id="TmtTitle">
 * <g id="Group">
 * <path id="Vector" d="M16.7276 0.122093L15.934 3.05233H15.8119C15.3845 2.50291 14.5298 2.25872 13.3699 2.25872H9.829V18.9244C9.829 19.5349 10.0732 20.0843 10.4395 20.5116V20.7558H6.22707V20.5116C6.65442 20.0843 6.89862 19.5349 6.89862 18.9244V2.19767H3.17459C1.95359 2.19767 0.915746 2.86919 0.183149 3.78488L0 3.66279L1.22099 0.0610465H1.28204C1.64834 0.18314 1.89254 0.244186 2.38094 0.244186H15.4456C15.934 0.244186 16.1782 0.122093 16.5445 0L16.7276 0.122093Z" fill="#373938"/>
 * <path id="Vector_2" d="M38.9498 2.13657V18.8633C38.9498 19.4738 39.194 20.0232 39.5603 20.4505V20.6947H35.4089C35.8973 19.9011 36.0805 18.497 36.0805 17.3372V10.0116H24.6642V17.3372C24.6642 18.5581 24.8473 19.9011 25.3357 20.6947H21.1843V20.4505C21.5506 20.0232 21.7948 19.4738 21.7948 18.8633V2.13657C21.7948 1.52611 21.5506 0.976687 21.1843 0.549362V0.305176H25.3357C24.8473 1.09878 24.6642 2.50285 24.6642 3.66273V8.05808H36.0194V3.66273C36.0194 2.4418 35.8363 1.09878 35.3479 0.305176H39.4992V0.549362C39.1329 0.976687 38.9498 1.52611 38.9498 2.13657Z" fill="#373938"/>
 * <path id="Vector_3" d="M58.8519 17.093L57.5699 20.8779C57.2036 20.8168 56.8983 20.6948 56.4099 20.6948H45.1157V20.4506C45.482 20.0232 45.7262 19.4738 45.7262 18.8634V2.13662C45.7262 1.52615 45.482 0.976733 45.1157 0.549407V0.305221H54.8226C55.4331 0.305221 55.9826 0.305221 56.4099 0.0610352H56.532V3.78487H56.4099C55.8605 2.56394 55.1889 2.07557 53.4795 2.07557H48.5956V8.05813H53.4185C53.9069 8.05813 54.1511 7.93603 54.4563 7.69185H54.5784V10.3779H54.4563C53.9069 10.0727 53.2353 9.82848 52.6859 9.82848H48.5956V18.6802H54.8226C56.8983 18.6802 57.9362 17.7645 58.7298 16.8488L58.8519 17.093Z" fill="#373938"/>
 * <path id="Vector_4" d="M96.5197 20.4505V20.6947H92.002C92.4294 19.9011 92.5515 18.497 92.4294 17.3372L91.5136 3.29645L84.0656 20.9389H83.6382L76.2512 3.23541L75.3355 17.3372C75.2744 18.5581 75.3355 19.9011 75.7628 20.6947H72.2219V20.4505C72.5882 20.0232 73.1377 18.8633 73.3208 16.8488L74.3587 2.13657C74.4197 1.52611 74.1755 0.976687 73.6871 0.549362V0.305176H78.2658L84.4319 15.2616L90.781 0.305176H95.0545V0.549362C94.5661 0.976687 94.3219 1.52611 94.383 2.13657L95.4208 16.8488C95.5429 18.8633 96.1534 20.0232 96.5197 20.4505Z" fill="#373938"/>
 * <path id="Vector_5" d="M120.817 20.4505V20.6947H115.995C116.056 19.4738 115.75 18.2528 115.262 17.0319L113.43 12.6366H106.471L104.639 17.0319C104.09 18.3139 103.846 19.5348 103.907 20.6947H100.122V20.4505C100.976 19.779 101.648 19.2296 102.258 17.7645L108.546 2.86913C108.913 2.01448 108.852 1.15983 108.485 0.549362V0.305176H111.416L118.742 17.7645C119.352 19.1685 119.963 19.718 120.817 20.4505ZM112.637 10.8052L109.89 4.21215L107.142 10.8052H112.637Z" fill="#373938"/>
 * <path id="Vector_6" d="M125.091 0.305176H129.181V0.549362C128.815 0.976687 128.571 1.52611 128.571 2.13657V18.8633C128.571 19.4738 128.815 20.0232 129.181 20.4505V20.6947H125.091V20.4505C125.457 20.0232 125.701 19.4738 125.701 18.8633V2.13657C125.701 1.52611 125.457 0.976687 125.091 0.549362V0.305176Z" fill="#373938"/>
 * <path id="Vector_7" d="M153.479 0.305176V0.549362C153.113 0.976687 152.868 1.52611 152.868 2.13657V20.9389H152.38L137.728 4.51738V17.2761C137.728 18.497 137.911 19.8401 138.4 20.6337H135.103V20.3895C135.469 19.9622 135.713 19.4127 135.713 18.8023V2.93018C135.713 1.89238 135.164 0.976687 134.553 0.549362V0.305176H137.85L150.793 14.7732V3.66273C150.793 2.4418 150.61 1.09878 150.121 0.305176H153.479Z" fill="#373938"/>
 * <path id="Vector_8" d="M182.05 0.122093L181.257 3.05233H181.135C180.707 2.50291 179.853 2.25872 178.693 2.25872H175.213V18.9244C175.213 19.5349 175.457 20.0843 175.823 20.5116V20.7558H171.611V20.5116C172.038 20.0843 172.282 19.5349 172.282 18.9244V2.19767H168.497C167.276 2.19767 166.239 2.86919 165.506 3.78488L165.323 3.66279L166.544 0.0610465H166.605C166.971 0.18314 167.215 0.244186 167.704 0.244186H180.768C181.257 0.244186 181.501 0.122093 181.867 0L182.05 0.122093Z" fill="#373938"/>
 * <path id="Vector_9" d="M202.624 20.4505V20.6947H197.801C197.862 19.4738 197.557 18.2528 197.069 17.0319L195.237 12.6366H188.277L186.446 17.0319C185.896 18.3139 185.652 19.5348 185.713 20.6947H181.928V20.4505C182.783 19.779 183.454 19.2296 184.065 17.7645L190.353 2.86913C190.719 2.01448 190.658 1.15983 190.292 0.549362V0.305176H193.222L200.548 17.7645C201.159 19.1685 201.769 19.718 202.624 20.4505ZM194.443 10.8052L191.696 4.21215L188.949 10.8052H194.443V10.8052Z" fill="#373938"/>
 * <path id="Vector_10" d="M221 14.5291C221 17.7645 218.619 21 212.819 21C211.232 21 208.241 20.8169 206.531 20.6948V20.4506C206.898 20.0233 207.142 19.4738 207.142 18.8634V2.13663C207.142 1.52616 206.898 0.976744 206.531 0.549419V0.305233C208.119 0.18314 210.377 0 212.026 0C216.91 0 218.863 2.13663 218.863 4.82267C218.863 6.71512 217.948 8.30233 216.177 9.03488C217.887 9.34012 221 10.9884 221 14.5291ZM211.659 1.77035C211.171 1.77035 210.561 1.77035 210.011 1.8314V8.6686H210.683C215.567 8.6686 216.177 6.89826 216.177 5.25C216.238 2.99128 214.895 1.77035 211.659 1.77035ZM218.009 14.7733C218.009 11.9041 216.299 10.2558 212.209 10.2558C211.354 10.2558 210.499 10.3169 210.072 10.3779V18.8634C211.049 18.9244 212.026 19.0465 212.758 19.0465C217.093 19.0465 218.009 16.8488 218.009 14.7733Z" fill="#373938"/>
 * <text id="WHOLESALE MADE FOR YOU" fill="#373938" xml:space="preserve" style="white-space: pre" font-family="Poppins" font-size="8" letter-spacing="0.2em"><tspan x="40.7937" y="38.8">WHOLESALE MADE FOR YOU</tspan></text>
 * </g>
 * </g>
 * </svg>
 *
 * ---------------------------------
 *
 * CONFIGURATION
 * ---------------------------------
 * {
 * 	"#tmtTitle": {
 * 		"type": "SELECTOR",
 * 		"constraint": "none",
 * 		"width": 221,
 * 		"height": 46
 * 	},
 * 	"#Group": {
 * 		"type": "SELECTOR",
 * 		"constraint": "none",
 * 		"width": 221,
 * 		"height": 46
 * 	},
 * 	"#Vector": {
 * 		"type": "SELECTOR",
 * 		"constraint": "xMidYMid meet",
 * 		"width": 14.468780517578125,
 * 		"height": 21
 * 	},
 * 	"#WHOLESALE_20MADE_20FOR_20YOU": {
 * 		"type": "SELECTOR",
 * 		"constraint": "xMidYMid meet",
 * 		"width": 162,
 * 		"height": 17
 * 	},
 * 	"#TmtTitle": {
 * 		"type": "SELECTOR",
 * 		"constraint": "none",
 * 		"width": 221,
 * 		"height": 46
 * 	}
 * }
 * ---------------------------------
 *
 * DESCRIPTION
 * ---------------------------------
 * No description provided!
 * ---------------------------------
 */

/** Component Properties Interface */
export type tProps = {
  style?: tStyle;
  svgStyle?: tStyle;
  debug?: boolean;
  isInsideScrollView?: boolean;
  svgRef?: () => void;
  onAnimationComplete?: () => void;
};
/***/

/***/

export type tStyle = StyleProp<ViewStyle>;
export type tTextStyle = StyleProp<TextStyle>;
/** Convenience for prop insertion from ast (no-color-literals/no-inline-styles) */

/** Local Styles */

const kLocalStyles = StyleSheet.create({
  kOverlay: {
    left: 0,
    position: "absolute",
    top: 0,
  },
});
/***/

/***/

/**
 * Auto-Generated Imp.Blue Component based on your design!
 * @param {tProps} props Developer interface to the component!
 * @returns {JSX.Element} JSX
 *
 * Description --
 * No description provided!
 */

export const TmtTitle = (props: {
  style?: tStyle;
  svgStyle?: tStyle;
  debug?: boolean;
  isInsideScrollView?: boolean;
  svgRef?: () => void;
  onAnimationComplete?: () => void;
}): JSX.Element => {
  const {
    style = {
      width: 221,
      height: 46,
    },
    svgStyle = {
      width: "100%",
      height: "100%",
    },
    svgRef,
  } = props;

  function checkFont(myStrFamily: string) {
    let aReturnFamily;

    if (FontList) {
      FontList.get((fontFamilies: Array<string>) => {
        if (fontFamilies.includes(myStrFamily)) {
          aReturnFamily = myStrFamily;
        } else {
          console.warn(`"${myStrFamily}" is not a valid font. Using "${fontFamilies[0]}" instead. `);
          aReturnFamily = fontFamilies[0];
        }
      });
    } else {
      aReturnFamily = myStrFamily;
    }

    return aReturnFamily;
  }

  /** Component Internal State */

  /** Component Internal Functions */

  /** Custom React-Hooks */

  /**
   * Custom hook to emulate onLayout events
   * (For use in web env only!)
   */

  /** End Custom React-Hooks */

  /** Component Render (Javascript-React Markup) */

  if (Platform.OS === "web") {
    return (
      <View style={style}>
        <Svg fill="none" id="svg_root" ref={svgRef} {...props} style={svgStyle}>
          <G id="TmtTitle">
            <Svg preserveAspectRatio="none" viewBox="0 0 221 46">
              <G id="Group">
                <Svg preserveAspectRatio="xMidYMid meet" viewBox="0 0 221 46">
                  <Path
                    id="Vector"
                    d="M16.7276 0.122093L15.934 3.05233H15.8119C15.3845 2.50291 14.5298 2.25872 13.3699 2.25872H9.829V18.9244C9.829 19.5349 10.0732 20.0843 10.4395 20.5116V20.7558H6.22707V20.5116C6.65442 20.0843 6.89862 19.5349 6.89862 18.9244V2.19767H3.17459C1.95359 2.19767 0.915746 2.86919 0.183149 3.78488L0 3.66279L1.22099 0.0610465H1.28204C1.64834 0.18314 1.89254 0.244186 2.38094 0.244186H15.4456C15.934 0.244186 16.1782 0.122093 16.5445 0L16.7276 0.122093Z"
                    fill="#373938"
                    strokeWidth="1"
                    vectorEffect="non-scaling-stroke"
                  />
                </Svg>
                <Path
                  id="Vector_2"
                  d="M38.9498 2.13657V18.8633C38.9498 19.4738 39.194 20.0232 39.5603 20.4505V20.6947H35.4089C35.8973 19.9011 36.0805 18.497 36.0805 17.3372V10.0116H24.6642V17.3372C24.6642 18.5581 24.8473 19.9011 25.3357 20.6947H21.1843V20.4505C21.5506 20.0232 21.7948 19.4738 21.7948 18.8633V2.13657C21.7948 1.52611 21.5506 0.976687 21.1843 0.549362V0.305176H25.3357C24.8473 1.09878 24.6642 2.50285 24.6642 3.66273V8.05808H36.0194V3.66273C36.0194 2.4418 35.8363 1.09878 35.3479 0.305176H39.4992V0.549362C39.1329 0.976687 38.9498 1.52611 38.9498 2.13657Z"
                  fill="#373938"
                  strokeWidth="1"
                  vectorEffect="non-scaling-stroke"
                />
                <Path
                  id="Vector_3"
                  d="M58.8519 17.093L57.5699 20.8779C57.2036 20.8168 56.8983 20.6948 56.4099 20.6948H45.1157V20.4506C45.482 20.0232 45.7262 19.4738 45.7262 18.8634V2.13662C45.7262 1.52615 45.482 0.976733 45.1157 0.549407V0.305221H54.8226C55.4331 0.305221 55.9826 0.305221 56.4099 0.0610352H56.532V3.78487H56.4099C55.8605 2.56394 55.1889 2.07557 53.4795 2.07557H48.5956V8.05813H53.4185C53.9069 8.05813 54.1511 7.93603 54.4563 7.69185H54.5784V10.3779H54.4563C53.9069 10.0727 53.2353 9.82848 52.6859 9.82848H48.5956V18.6802H54.8226C56.8983 18.6802 57.9362 17.7645 58.7298 16.8488L58.8519 17.093Z"
                  fill="#373938"
                  strokeWidth="1"
                  vectorEffect="non-scaling-stroke"
                />
                <Path
                  id="Vector_4"
                  d="M96.5197 20.4505V20.6947H92.002C92.4294 19.9011 92.5515 18.497 92.4294 17.3372L91.5136 3.29645L84.0656 20.9389H83.6382L76.2512 3.23541L75.3355 17.3372C75.2744 18.5581 75.3355 19.9011 75.7628 20.6947H72.2219V20.4505C72.5882 20.0232 73.1377 18.8633 73.3208 16.8488L74.3587 2.13657C74.4197 1.52611 74.1755 0.976687 73.6871 0.549362V0.305176H78.2658L84.4319 15.2616L90.781 0.305176H95.0545V0.549362C94.5661 0.976687 94.3219 1.52611 94.383 2.13657L95.4208 16.8488C95.5429 18.8633 96.1534 20.0232 96.5197 20.4505Z"
                  fill="#373938"
                  strokeWidth="1"
                  vectorEffect="non-scaling-stroke"
                />
                <Path
                  id="Vector_5"
                  d="M120.817 20.4505V20.6947H115.995C116.056 19.4738 115.75 18.2528 115.262 17.0319L113.43 12.6366H106.471L104.639 17.0319C104.09 18.3139 103.846 19.5348 103.907 20.6947H100.122V20.4505C100.976 19.779 101.648 19.2296 102.258 17.7645L108.546 2.86913C108.913 2.01448 108.852 1.15983 108.485 0.549362V0.305176H111.416L118.742 17.7645C119.352 19.1685 119.963 19.718 120.817 20.4505ZM112.637 10.8052L109.89 4.21215L107.142 10.8052H112.637Z"
                  fill="#373938"
                  strokeWidth="1"
                  vectorEffect="non-scaling-stroke"
                />
                <Path
                  id="Vector_6"
                  d="M125.091 0.305176H129.181V0.549362C128.815 0.976687 128.571 1.52611 128.571 2.13657V18.8633C128.571 19.4738 128.815 20.0232 129.181 20.4505V20.6947H125.091V20.4505C125.457 20.0232 125.701 19.4738 125.701 18.8633V2.13657C125.701 1.52611 125.457 0.976687 125.091 0.549362V0.305176Z"
                  fill="#373938"
                  strokeWidth="1"
                  vectorEffect="non-scaling-stroke"
                />
                <Path
                  id="Vector_7"
                  d="M153.479 0.305176V0.549362C153.113 0.976687 152.868 1.52611 152.868 2.13657V20.9389H152.38L137.728 4.51738V17.2761C137.728 18.497 137.911 19.8401 138.4 20.6337H135.103V20.3895C135.469 19.9622 135.713 19.4127 135.713 18.8023V2.93018C135.713 1.89238 135.164 0.976687 134.553 0.549362V0.305176H137.85L150.793 14.7732V3.66273C150.793 2.4418 150.61 1.09878 150.121 0.305176H153.479Z"
                  fill="#373938"
                  strokeWidth="1"
                  vectorEffect="non-scaling-stroke"
                />
                <Path
                  id="Vector_8"
                  d="M182.05 0.122093L181.257 3.05233H181.135C180.707 2.50291 179.853 2.25872 178.693 2.25872H175.213V18.9244C175.213 19.5349 175.457 20.0843 175.823 20.5116V20.7558H171.611V20.5116C172.038 20.0843 172.282 19.5349 172.282 18.9244V2.19767H168.497C167.276 2.19767 166.239 2.86919 165.506 3.78488L165.323 3.66279L166.544 0.0610465H166.605C166.971 0.18314 167.215 0.244186 167.704 0.244186H180.768C181.257 0.244186 181.501 0.122093 181.867 0L182.05 0.122093Z"
                  fill="#373938"
                  strokeWidth="1"
                  vectorEffect="non-scaling-stroke"
                />
                <Path
                  id="Vector_9"
                  d="M202.624 20.4505V20.6947H197.801C197.862 19.4738 197.557 18.2528 197.069 17.0319L195.237 12.6366H188.277L186.446 17.0319C185.896 18.3139 185.652 19.5348 185.713 20.6947H181.928V20.4505C182.783 19.779 183.454 19.2296 184.065 17.7645L190.353 2.86913C190.719 2.01448 190.658 1.15983 190.292 0.549362V0.305176H193.222L200.548 17.7645C201.159 19.1685 201.769 19.718 202.624 20.4505ZM194.443 10.8052L191.696 4.21215L188.949 10.8052H194.443V10.8052Z"
                  fill="#373938"
                  strokeWidth="1"
                  vectorEffect="non-scaling-stroke"
                />
                <Path
                  id="Vector_10"
                  d="M221 14.5291C221 17.7645 218.619 21 212.819 21C211.232 21 208.241 20.8169 206.531 20.6948V20.4506C206.898 20.0233 207.142 19.4738 207.142 18.8634V2.13663C207.142 1.52616 206.898 0.976744 206.531 0.549419V0.305233C208.119 0.18314 210.377 0 212.026 0C216.91 0 218.863 2.13663 218.863 4.82267C218.863 6.71512 217.948 8.30233 216.177 9.03488C217.887 9.34012 221 10.9884 221 14.5291ZM211.659 1.77035C211.171 1.77035 210.561 1.77035 210.011 1.8314V8.6686H210.683C215.567 8.6686 216.177 6.89826 216.177 5.25C216.238 2.99128 214.895 1.77035 211.659 1.77035ZM218.009 14.7733C218.009 11.9041 216.299 10.2558 212.209 10.2558C211.354 10.2558 210.499 10.3169 210.072 10.3779V18.8634C211.049 18.9244 212.026 19.0465 212.758 19.0465C217.093 19.0465 218.009 16.8488 218.009 14.7733Z"
                  fill="#373938"
                  strokeWidth="1"
                  vectorEffect="non-scaling-stroke"
                />
                <Svg preserveAspectRatio="xMidYMid meet" viewBox="0 0 221 46">
                  <Text
                    id="WHOLESALE_20MADE_20FOR_20YOU"
                    fill="#373938"
                    fontSize={8}
                    letterSpacing="0.2em"
                    fontFamily={checkFont("Poppins")}
                  >
                  </Text>
                </Svg>
              </G>
            </Svg>
          </G>
        </Svg>
      </View>
    );
  }

  return (
    <View style={style}>
      <Svg
        id="native_constraint_wrapper"
        preserveAspectRatio="xMidYMid meet"
        viewBox="0 0 221 46"
        style={[svgStyle, kLocalStyles.kOverlay]}
      >
        <Path
          id="Vector"
          d="M16.7276 0.122093L15.934 3.05233H15.8119C15.3845 2.50291 14.5298 2.25872 13.3699 2.25872H9.829V18.9244C9.829 19.5349 10.0732 20.0843 10.4395 20.5116V20.7558H6.22707V20.5116C6.65442 20.0843 6.89862 19.5349 6.89862 18.9244V2.19767H3.17459C1.95359 2.19767 0.915746 2.86919 0.183149 3.78488L0 3.66279L1.22099 0.0610465H1.28204C1.64834 0.18314 1.89254 0.244186 2.38094 0.244186H15.4456C15.934 0.244186 16.1782 0.122093 16.5445 0L16.7276 0.122093Z"
          fill="#373938"
          strokeWidth="1"
          vectorEffect="non-scaling-stroke"
        />
      </Svg>
      <Svg
        id="native_constraint_wrapper"
        preserveAspectRatio="none"
        viewBox="0 0 221 46"
        style={[svgStyle, kLocalStyles.kOverlay]}
      >
        <Path
          id="Vector_2"
          d="M38.9498 2.13657V18.8633C38.9498 19.4738 39.194 20.0232 39.5603 20.4505V20.6947H35.4089C35.8973 19.9011 36.0805 18.497 36.0805 17.3372V10.0116H24.6642V17.3372C24.6642 18.5581 24.8473 19.9011 25.3357 20.6947H21.1843V20.4505C21.5506 20.0232 21.7948 19.4738 21.7948 18.8633V2.13657C21.7948 1.52611 21.5506 0.976687 21.1843 0.549362V0.305176H25.3357C24.8473 1.09878 24.6642 2.50285 24.6642 3.66273V8.05808H36.0194V3.66273C36.0194 2.4418 35.8363 1.09878 35.3479 0.305176H39.4992V0.549362C39.1329 0.976687 38.9498 1.52611 38.9498 2.13657Z"
          fill="#373938"
          strokeWidth="1"
          vectorEffect="non-scaling-stroke"
        />
      </Svg>
      <Svg
        id="native_constraint_wrapper"
        preserveAspectRatio="none"
        viewBox="0 0 221 46"
        style={[svgStyle, kLocalStyles.kOverlay]}
      >
        <Path
          id="Vector_3"
          d="M58.8519 17.093L57.5699 20.8779C57.2036 20.8168 56.8983 20.6948 56.4099 20.6948H45.1157V20.4506C45.482 20.0232 45.7262 19.4738 45.7262 18.8634V2.13662C45.7262 1.52615 45.482 0.976733 45.1157 0.549407V0.305221H54.8226C55.4331 0.305221 55.9826 0.305221 56.4099 0.0610352H56.532V3.78487H56.4099C55.8605 2.56394 55.1889 2.07557 53.4795 2.07557H48.5956V8.05813H53.4185C53.9069 8.05813 54.1511 7.93603 54.4563 7.69185H54.5784V10.3779H54.4563C53.9069 10.0727 53.2353 9.82848 52.6859 9.82848H48.5956V18.6802H54.8226C56.8983 18.6802 57.9362 17.7645 58.7298 16.8488L58.8519 17.093Z"
          fill="#373938"
          strokeWidth="1"
          vectorEffect="non-scaling-stroke"
        />
      </Svg>
      <Svg
        id="native_constraint_wrapper"
        preserveAspectRatio="none"
        viewBox="0 0 221 46"
        style={[svgStyle, kLocalStyles.kOverlay]}
      >
        <Path
          id="Vector_4"
          d="M96.5197 20.4505V20.6947H92.002C92.4294 19.9011 92.5515 18.497 92.4294 17.3372L91.5136 3.29645L84.0656 20.9389H83.6382L76.2512 3.23541L75.3355 17.3372C75.2744 18.5581 75.3355 19.9011 75.7628 20.6947H72.2219V20.4505C72.5882 20.0232 73.1377 18.8633 73.3208 16.8488L74.3587 2.13657C74.4197 1.52611 74.1755 0.976687 73.6871 0.549362V0.305176H78.2658L84.4319 15.2616L90.781 0.305176H95.0545V0.549362C94.5661 0.976687 94.3219 1.52611 94.383 2.13657L95.4208 16.8488C95.5429 18.8633 96.1534 20.0232 96.5197 20.4505Z"
          fill="#373938"
          strokeWidth="1"
          vectorEffect="non-scaling-stroke"
        />
      </Svg>
      <Svg
        id="native_constraint_wrapper"
        preserveAspectRatio="none"
        viewBox="0 0 221 46"
        style={[svgStyle, kLocalStyles.kOverlay]}
      >
        <Path
          id="Vector_5"
          d="M120.817 20.4505V20.6947H115.995C116.056 19.4738 115.75 18.2528 115.262 17.0319L113.43 12.6366H106.471L104.639 17.0319C104.09 18.3139 103.846 19.5348 103.907 20.6947H100.122V20.4505C100.976 19.779 101.648 19.2296 102.258 17.7645L108.546 2.86913C108.913 2.01448 108.852 1.15983 108.485 0.549362V0.305176H111.416L118.742 17.7645C119.352 19.1685 119.963 19.718 120.817 20.4505ZM112.637 10.8052L109.89 4.21215L107.142 10.8052H112.637Z"
          fill="#373938"
          strokeWidth="1"
          vectorEffect="non-scaling-stroke"
        />
      </Svg>
      <Svg
        id="native_constraint_wrapper"
        preserveAspectRatio="none"
        viewBox="0 0 221 46"
        style={[svgStyle, kLocalStyles.kOverlay]}
      >
        <Path
          id="Vector_6"
          d="M125.091 0.305176H129.181V0.549362C128.815 0.976687 128.571 1.52611 128.571 2.13657V18.8633C128.571 19.4738 128.815 20.0232 129.181 20.4505V20.6947H125.091V20.4505C125.457 20.0232 125.701 19.4738 125.701 18.8633V2.13657C125.701 1.52611 125.457 0.976687 125.091 0.549362V0.305176Z"
          fill="#373938"
          strokeWidth="1"
          vectorEffect="non-scaling-stroke"
        />
      </Svg>
      <Svg
        id="native_constraint_wrapper"
        preserveAspectRatio="none"
        viewBox="0 0 221 46"
        style={[svgStyle, kLocalStyles.kOverlay]}
      >
        <Path
          id="Vector_7"
          d="M153.479 0.305176V0.549362C153.113 0.976687 152.868 1.52611 152.868 2.13657V20.9389H152.38L137.728 4.51738V17.2761C137.728 18.497 137.911 19.8401 138.4 20.6337H135.103V20.3895C135.469 19.9622 135.713 19.4127 135.713 18.8023V2.93018C135.713 1.89238 135.164 0.976687 134.553 0.549362V0.305176H137.85L150.793 14.7732V3.66273C150.793 2.4418 150.61 1.09878 150.121 0.305176H153.479Z"
          fill="#373938"
          strokeWidth="1"
          vectorEffect="non-scaling-stroke"
        />
      </Svg>
      <Svg
        id="native_constraint_wrapper"
        preserveAspectRatio="none"
        viewBox="0 0 221 46"
        style={[svgStyle, kLocalStyles.kOverlay]}
      >
        <Path
          id="Vector_8"
          d="M182.05 0.122093L181.257 3.05233H181.135C180.707 2.50291 179.853 2.25872 178.693 2.25872H175.213V18.9244C175.213 19.5349 175.457 20.0843 175.823 20.5116V20.7558H171.611V20.5116C172.038 20.0843 172.282 19.5349 172.282 18.9244V2.19767H168.497C167.276 2.19767 166.239 2.86919 165.506 3.78488L165.323 3.66279L166.544 0.0610465H166.605C166.971 0.18314 167.215 0.244186 167.704 0.244186H180.768C181.257 0.244186 181.501 0.122093 181.867 0L182.05 0.122093Z"
          fill="#373938"
          strokeWidth="1"
          vectorEffect="non-scaling-stroke"
        />
      </Svg>
      <Svg
        id="native_constraint_wrapper"
        preserveAspectRatio="none"
        viewBox="0 0 221 46"
        style={[svgStyle, kLocalStyles.kOverlay]}
      >
        <Path
          id="Vector_9"
          d="M202.624 20.4505V20.6947H197.801C197.862 19.4738 197.557 18.2528 197.069 17.0319L195.237 12.6366H188.277L186.446 17.0319C185.896 18.3139 185.652 19.5348 185.713 20.6947H181.928V20.4505C182.783 19.779 183.454 19.2296 184.065 17.7645L190.353 2.86913C190.719 2.01448 190.658 1.15983 190.292 0.549362V0.305176H193.222L200.548 17.7645C201.159 19.1685 201.769 19.718 202.624 20.4505ZM194.443 10.8052L191.696 4.21215L188.949 10.8052H194.443V10.8052Z"
          fill="#373938"
          strokeWidth="1"
          vectorEffect="non-scaling-stroke"
        />
      </Svg>
      <Svg
        id="native_constraint_wrapper"
        preserveAspectRatio="none"
        viewBox="0 0 221 46"
        style={[svgStyle, kLocalStyles.kOverlay]}
      >
        <Path
          id="Vector_10"
          d="M221 14.5291C221 17.7645 218.619 21 212.819 21C211.232 21 208.241 20.8169 206.531 20.6948V20.4506C206.898 20.0233 207.142 19.4738 207.142 18.8634V2.13663C207.142 1.52616 206.898 0.976744 206.531 0.549419V0.305233C208.119 0.18314 210.377 0 212.026 0C216.91 0 218.863 2.13663 218.863 4.82267C218.863 6.71512 217.948 8.30233 216.177 9.03488C217.887 9.34012 221 10.9884 221 14.5291ZM211.659 1.77035C211.171 1.77035 210.561 1.77035 210.011 1.8314V8.6686H210.683C215.567 8.6686 216.177 6.89826 216.177 5.25C216.238 2.99128 214.895 1.77035 211.659 1.77035ZM218.009 14.7733C218.009 11.9041 216.299 10.2558 212.209 10.2558C211.354 10.2558 210.499 10.3169 210.072 10.3779V18.8634C211.049 18.9244 212.026 19.0465 212.758 19.0465C217.093 19.0465 218.009 16.8488 218.009 14.7733Z"
          fill="#373938"
          strokeWidth="1"
          vectorEffect="non-scaling-stroke"
        />
      </Svg>
      <Svg
        id="native_constraint_wrapper"
        preserveAspectRatio="xMidYMid meet"
        viewBox="0 0 221 46"
        style={[svgStyle, kLocalStyles.kOverlay]}
      >
        <Text
          id="WHOLESALE_20MADE_20FOR_20YOU"
          fill="#373938"
          fontSize={8}
          letterSpacing="0.2em"
          fontFamily={checkFont("Poppins")}
        >
          <TSpan x={40.7937} y={38.8} id="WHOLESALE_20MADE_20FOR_20YOU_elem0">
            {"WHOLESALE MADE FOR YOU"}
          </TSpan>
        </Text>
      </Svg>
    </View>
  );
};
/***/

export default React.memo(TmtTitle);
